import { setMessageEditorStagingText } from '../../actions/messageEditorActions';
import { startTranscribing, cancelVoiceRecording, transcribeError } from '../reducers/voiceInputSlice';

// TODO: Remove once real transcription API is wired up
const MOCK_TRANSCRIBED_TEXT = 'Hello, this is a test transcription from voice input.';
const MOCK_SHOULD_FAIL = false;
export const mockTranscribeVoiceInput = () => dispatch => {
  dispatch(startTranscribing());
  setTimeout(() => {
    if (MOCK_SHOULD_FAIL) {
      dispatch(transcribeError());
    } else {
      dispatch(setMessageEditorStagingText(MOCK_TRANSCRIBED_TEXT));
      dispatch(cancelVoiceRecording());
    }
  }, 2000);
};